module.exports = __webpack_public_path__ + "img/del.e234630e.png";